module.exports = __webpack_public_path__ + "static/valeria-36b1592e22761ba02cbcae7aef4ecd79.jpeg";